import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { DepositInstruments } from './index.types';
import { mapInstruments } from './mapping';

const instrumentFragment = gql`
  fragment InstrumentFragment on ClearingDepositInstrument {
    type
    currency
    minimum
    maximum
    details {
      __typename
      ... on ClearingProviderWalletTransferPaymentSystem {
        id
        name
        fee
      }
      ... on ClearingBankCardPaymentSystem {
        id
        fee
      }
    }
  }
`;

const query = gql`
  query DepositInstruments {
    clearing {
      depositInstruments(product: "UTCOM") {
        ...InstrumentFragment
      }
    }
  }
  ${instrumentFragment}
`;

export const useTabs = () => {
  const { data, loading, error } = useQuery<DepositInstruments>(query);

  const { tabs, idToTab } = useMemo(
    () => mapInstruments(data?.clearing?.depositInstruments || []),
    [data?.clearing?.depositInstruments]
  );

  return {
    loading,
    error,
    tabs,
    idToTab,
  };
};
